export interface VoivodeshipOption {
  value: string;
  label: string;
}

export interface CountyOption {
  value: string;
  label: string;
}

export const VOIVODESHIPS: VoivodeshipOption[] = [
  { value: 'dolnoslaskie', label: 'Dolnośląskie' },
  { value: 'kujawsko-pomorskie', label: 'Kujawsko-pomorskie' },
  { value: 'lodzkie', label: 'Łódzkie' },
  { value: 'lubelskie', label: 'Lubelskie' },
  { value: 'lubuskie', label: 'Lubuskie' },
  { value: 'malopolskie', label: 'Małopolskie' },
  { value: 'mazowieckie', label: 'Mazowieckie' },
  { value: 'opolskie', label: 'Opolskie' },
  { value: 'podkarpackie', label: 'Podkarpackie' },
  { value: 'podlaskie', label: 'Podlaskie' },
  { value: 'pomorskie', label: 'Pomorskie' },
  { value: 'slaskie', label: 'Śląskie' },
  { value: 'swietokrzyskie', label: 'Świętokrzyskie' },
  { value: 'warminsko-mazurskie', label: 'Warmińsko-mazurskie' },
  { value: 'wielkopolskie', label: 'Wielkopolskie' },
  { value: 'zachodniopomorskie', label: 'Zachodniopomorskie' },
];

function toOption(name: string): CountyOption {
  return { value: name, label: name };
}

export const COUNTIES_BY_VOIVODESHIP: Record<string, CountyOption[]> = {
  dolnoslaskie: [
    'Bolesławiec',
    'Dzierżoniów',
    'Głogów',
    'Góra',
    'Jawor',
    'Jelenia Góra',
    'Kamienna Góra',
    'Kłodzko',
    'Legnica',
    'Lubań',
    'Lubin',
    'Lwówek Śląski',
    'Milicz',
    'Oleśnica',
    'Oława',
    'Polkowice',
    'Strzelin',
    'Środa Śląska',
    'Świdnica',
    'Trzebnica',
    'Wałbrzych',
    'Wołów',
    'Wrocław',
    'Ząbkowice Śląskie',
    'Zgorzelec',
    'Złotoryja',
  ].map(toOption),
  'kujawsko-pomorskie': [
    'Aleksandrów Kujawski',
    'Brodnica',
    'Bydgoszcz',
    'Chełmno',
    'Golub-Dobrzyń',
    'Grudziądz',
    'Inowrocław',
    'Lipno',
    'Mogilno',
    'Nakło nad Notecią',
    'Radziejów',
    'Rypin',
    'Sępólno Krajeńskie',
    'Świecie',
    'Toruń',
    'Tucholskie',
    'Wąbrzeźno',
    'Włocławek',
    'Żnin',
  ].map(toOption),
  lubelskie: [
    'Biała Podlaska',
    'Biłgoraj',
    'Chełm',
    'Hrubieszów',
    'Janów Lubelski',
    'Kraśnik',
    'Krasnystaw',
    'Łęczna',
    'Lublin',
    'Łuków',
    'Opole Lubelskie',
    'Parczew',
    'Puławy',
    'Radzyń Podlaski',
    'Ryki',
    'Świdnik',
    'Tomaszów Lubelski',
    'Włodawa',
    'Zamość',
  ].map(toOption),
  lubuskie: [
    'Gorzów Wielkopolski',
    'Krosno Odrzańskie',
    'Międzyrzecz',
    'Nowa Sól',
    'Słubice',
    'Strzelce-Drezdenko',
    'Sulęcin',
    'Świebodzin',
    'Wschowa',
    'Zielona Góra',
    'Żagań',
    'Żary',
  ].map(toOption),
  lodzkie: [
    'Bełchatów',
    'Brzeziny',
    'Kutno',
    'Łask',
    'Łęczyca',
    'Łowicz',
    'Łódź',
    'Opoczno',
    'Pabianice',
    'Pajęczno',
    'Piotrków Trybunalski',
    'Poddębice',
    'Radomsko',
    'Rawa Mazowiecka',
    'Sieradz',
    'Skierniewice',
    'Tomaszów Mazowiecki',
    'Wieluń',
    'Wieruszów',
    'Zduńska Wola',
    'Zgierz',
  ].map(toOption),
  malopolskie: [
    'Bocheński',
    'Brzeski',
    'Chrzanów',
    'Dąbrowa Tarnowska',
    'Gorlice',
    'Kraków',
    'Limanowa',
    'Miechów',
    'Myślenice',
    'Nowy Sącz',
    'Nowy Targ',
    'Olkusz',
    'Oświęcim',
    'Proszowice',
    'Sucha Beskidzka',
    'Tarnów',
    'Tatrzański',
    'Wadowice',
    'Wieliczka',
  ].map(toOption),
  mazowieckie: [
    'Białobrzegi',
    'Ciechanów',
    'Garwolin',
    'Gostynin',
    'Grodzisk Mazowiecki',
    'Grójec',
    'Kozienice',
    'Legionowo',
    'Lipsko',
    'Łosice',
    'Maków Mazowiecki',
    'Mińsk Mazowiecki',
    'Mława',
    'Nowy Dwór Mazowiecki',
    'Ostrołęka',
    'Ostrów Mazowiecka',
    'Otwock',
    'Piaseczno',
    'Płock',
    'Płońsk',
    'Pruszków',
    'Przasnysz',
    'Przysucha',
    'Pułtusk',
    'Radom',
    'Siedlce',
    'Sierpc',
    'Sochaczew',
    'Sokołów Podlaski',
    'Szydłowiec',
    'Warszawa',
    'Węgrów',
    'Wołomin',
    'Wyszków',
    'Wyszogród',
    'Żuromin',
    'Żyrardów',
  ].map(toOption),
  opolskie: [
    'Brzeg',
    'Głubczyce',
    'Kędzierzyn-Koźle',
    'Kluczbork',
    'Krapkowice',
    'Namysłów',
    'Nysa',
    'Olesno',
    'Opole',
    'Prudnik',
    'Strzelce Opolskie',
  ].map(toOption),
  podkarpackie: [
    'Bieszczadzki',
    'Brzozów',
    'Dębica',
    'Jarosław',
    'Jasło',
    'Kolbuszowa',
    'Krosno',
    'Lesko',
    'Leżajsk',
    'Lubaczów',
    'Łańcut',
    'Mielec',
    'Nisko',
    'Przemyśl',
    'Przeworsk',
    'Ropczyce-Sędziszów',
    'Rzeszów',
    'Sanok',
    'Stalowa Wola',
    'Strzyżów',
    'Tarnobrzeg',
  ].map(toOption),
  podlaskie: [
    'Augustów',
    'Białystok',
    'Bielsk Podlaski',
    'Grajewo',
    'Hajnówka',
    'Kolno',
    'Łomża',
    'Mońki',
    'Sejny',
    'Siemiatycze',
    'Sokółka',
    'Suwałki',
    'Wysokie Mazowieckie',
    'Zambrów',
  ].map(toOption),
  pomorskie: [
    'Bytów',
    'Chojnice',
    'Człuchów',
    'Gdańsk',
    'Gdynia',
    'Kościerzyna',
    'Kwidzyn',
    'Lębork',
    'Malbork',
    'Nowy Dwór Gdański',
    'Puck',
    'Słupsk',
    'Sopot',
    'Starogard Gdański',
    'Sztum',
    'Tczew',
    'Wejherowo',
  ].map(toOption),
  slaskie: [
    'Będzin',
    'Bielsko-Biała',
    'Bytom',
    'Chorzów',
    'Cieszyn',
    'Częstochowa',
    'Dąbrowa Górnicza',
    'Gliwice',
    'Jaworzno',
    'Jastrzębie-Zdrój',
    'Katowice',
    'Kłobuck',
    'Lubliniecki',
    'Mikołów',
    'Mysłowice',
    'Myszków',
    'Piekary Śląskie',
    'Pszczyna',
    'Racibórz',
    'Ruda Śląska',
    'Rybnik',
    'Rybnicki',
    'Siemianowice Śląskie',
    'Sosnowiec',
    'Świętochłowice',
    'Tarnowskie Góry',
    'Tychy',
    'Wodzisław Śląski',
    'Zabrze',
    'Zawiercie',
    'Żory',
    'Żywiec',
  ].map(toOption),
  swietokrzyskie: [
    'Busko-Zdrój',
    'Jędrzejów',
    'Kazimierza Wielka',
    'Kielce',
    'Końskie',
    'Opatów',
    'Ostrowiec Świętokrzyski',
    'Pińczów',
    'Sandomierz',
    'Skarżysko-Kamienna',
    'Starachowice',
    'Staszów',
    'Włoszczowa',
  ].map(toOption),
  'warminsko-mazurskie': [
    'Bartoszyce',
    'Braniewo',
    'Działdowo',
    'Elbląg',
    'Ełk',
    'Giżycko',
    'Gołdap',
    'Iława',
    'Kętrzyn',
    'Lidzbark Warmiński',
    'Mrągowo',
    'Nidzica',
    'Nowe Miasto Lubawskie',
    'Olecko',
    'Olsztyn',
    'Ostróda',
    'Pisz',
    'Szczytno',
    'Węgorzewo',
  ].map(toOption),
  wielkopolskie: [
    'Chodzież',
    'Czarnków-Trzcianka',
    'Gniezno',
    'Gostyń',
    'Grodzisk Wielkopolski',
    'Jarocin',
    'Kalisz',
    'Kępno',
    'Koło',
    'Konin',
    'Kościan',
    'Krotoszyn',
    'Leszno',
    'Międzychód',
    'Nowy Tomyśl',
    'Oborniki',
    'Ostrów Wielkopolski',
    'Ostrzeszów',
    'Piła',
    'Pleszew',
    'Poznań',
    'Rawicz',
    'Słupca',
    'Szamotuły',
    'Środa Wielkopolska',
    'Śrem',
    'Turek',
    'Wągrowiec',
    'Wolsztyn',
    'Września',
    'Złotów',
  ].map(toOption),
  zachodniopomorskie: [
    'Białogard',
    'Choszczno',
    'Drawsko Pomorskie',
    'Goleniów',
    'Gryfice',
    'Gryfino',
    'Kamień Pomorski',
    'Kołobrzeg',
    'Koszalin',
    'Łobez',
    'Myślibórz',
    'Police',
    'Pyrzyce',
    'Sławno',
    'Stargard',
    'Szczecin',
    'Szczecinek',
    'Świdwin',
    'Świnoujście',
    'Wałcz',
  ].map(toOption),
};
